import { useCallback, useRef, useState } from 'react'
import { useAppDispatch } from '../../redux/app/hooks'
import { addItemToBasketApi } from '../../redux/slices/basket/basketApi'
import { syncActiveBasketRedux } from '../../redux/slices/basket/basketSlice'
import { ChatAddStatus, submitChatAddToBasket } from './chatAddToBasket'
import { ChatProduct } from './types'

/**
 * Karttan sepete ekleme (Faz-29 Artım A). Redux thunk'ı (addItemToBasketRedux) BİLEREK
 * kullanılmaz: thunk header'ın global popup'ını ve spinner'ını tetikler, ikisi de sohbet
 * panelinin arkasında kalır. Sonuç kartın içinde gösterilir, rozet syncActiveBasket ile eşitlenir.
 */
export function useChatAddToBasket(product: ChatProduct) {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<ChatAddStatus>({ kind: 'idle' })
  const inFlight = useRef(false)

  const add = useCallback(
    async (quantity: number) => {
      if (inFlight.current) return // çift tıklama koruması; buton da kilitli
      inFlight.current = true
      setStatus({ kind: 'loading' })

      const result = await submitChatAddToBasket(product, quantity, addItemToBasketApi)
      inFlight.current = false

      if (result.ok) {
        dispatch(syncActiveBasketRedux(result.basket))
        setStatus({ kind: 'added', quantity: result.quantity })
      } else {
        setStatus({ kind: 'error', message: result.message })
      }
    },
    [dispatch, product]
  )

  return { status, add }
}
